module.exports = __webpack_public_path__ + "images/track-button-ec9c3136.png";